module.exports = __webpack_public_path__ + "map-location.0dc0406e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/map-location.png
// module id = 2245
// module chunks = 0